import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { components } from 'react-select';
import { useMemo } from 'react';
export default function DSelectPlaceholder(_a) {
    var { selectProps, innerProps: innerPropsProp, children } = _a, props = __rest(_a, ["selectProps", "innerProps", "children"]);
    const id = useMemo(() => `${selectProps.inputId}Placeholder`, [selectProps.inputId]);
    const innerProps = useMemo(() => (Object.assign(Object.assign({}, innerPropsProp), { id })), [innerPropsProp, id]);
    return (_jsx(components.Placeholder, Object.assign({ innerProps: innerProps, selectProps: selectProps }, props, { children: children })));
}
//# sourceMappingURL=DSelectPlaceholder.js.map